import { Field, Input, Label } from "@headlessui/react";
import { Loading } from "../../../../../components/Loading";
import { localeShortDateTime } from "../../../../../app/datetimeUtils";
import { DistrictCleverInfoResult } from "../../../districtsApiSlice";

interface CleverSettingsFormProps {
	data?: DistrictCleverInfoResult;
	setData: (data: any) => void;
	isLoading: boolean;
}

export default function CleverSettingsForm({ data, setData, isLoading }: CleverSettingsFormProps) {
	return (
		<div className="flex flex-col mt-3 gap-x-12 w-full">
			<Loading loading={isLoading} />
			{data && (
				<div className="grid grid-cols-1 gap-x-6 gap-y-3 sm:grid-cols-6">
					<Field className="col-span-6">
						<Label htmlFor="cleverId" className="font-medium text-sm">
							Clever ID
						</Label>
						<Input
							id="cleverId"
							name="cleverId"
							type="text"
							maxLength={24}
							className={
								"block w-full mt-1 rounded-lg border-0 text-gray-900 text-sm ring-1 ring-inset ring-gray-300 read-only:bg-slate-200/75 read-only:focus:ring-gray-300 read-only:focus:ring-1 focus:ring-2 focus:ring-inset focus:ring-primary-600"
							}
							value={(data as DistrictCleverInfoResult).cleverId ?? ""}
							onChange={(e) =>
								setData({
									...data,
									cleverId: e.target.value,
								})
							}
						/>
					</Field>
					<Field className="col-span-6">
						<Label htmlFor="lastSyncAt" className="font-medium text-sm">
							Last Sync At
						</Label>
						<Input
							id="lastSyncAt"
							name="lastSyncAt"
							type="text"
							readOnly
							className={
								"block w-full mt-1 rounded-lg border-0 text-gray-900 text-sm ring-1 ring-inset ring-gray-300 read-only:bg-slate-200/75 read-only:focus:ring-gray-300 read-only:focus:ring-1 focus:ring-2 focus:ring-inset focus:ring-primary-600"
							}
							value={
								(data as DistrictCleverInfoResult).lastSyncAt == undefined
									? ""
									: localeShortDateTime(
											(data as DistrictCleverInfoResult).lastSyncAt,
											true
										)
							}
						/>
					</Field>
				</div>
			)}
		</div>
	);
}
